import { render } from "./TrainingModelRowComponent.vue?vue&type=template&id=396faf7c&scoped=true"
import script from "./TrainingModelRowComponent.vue?vue&type=script&lang=js"
export * from "./TrainingModelRowComponent.vue?vue&type=script&lang=js"

import "./TrainingModelRowComponent.vue?vue&type=style&index=0&id=396faf7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396faf7c"]])

export default __exports__